type DirectionalMapType = {
  [key: number]: string;
};
export const tooltipDirectionMap: DirectionalMapType = {
  /**
   * Appear above the target element, with the left edges of the callout and target aligning.
   */
  0: "above-start",
  /**
   * Appear above the target element, with the centers of the callout and target aligning.
   */
  1: "above",
  /**
   * Appear above the target element, with the right edges of the callout and target aligning.
   */
  2: "above-end",

  3: "above",
  /**
   * Appear below the target element, with the centers of the callout and target aligning.
   */
  4: "below",
  /**
   * Appear below the target element, with the centers of the callout and target aligning.
   */
  5: "below",
  /**
   * Appear below the target element, with the right edges of the callout and target aligning.
   */
  6: "below-end",

  7: "below",
  /**
   * Appear to the left of the target element, with the top edges of the callout and target aligning.
   */
  8: "before-top",
  /**
   * Appear to the left of the target element, with the centers of the callout and target aligning.
   */
  9: "before",
  /**
   * Appear to the left of the target element, with the bottom edges of the callout and target aligning.
   */
  10: "before-bottom",
  /**
   * Appear to the right of the target element, with the top edges of the callout and target aligning.
   */
  11: "after-top",
  /**
   * Appear to the right of the target element, with the centers of the callout and target aligning.
   */
  12: "after",
  /**
   * Appear to the right of the target element, with the bottom edges of the callout and target aligning.
   */
  13: "after-bottom",
};
